// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ExpenseReport } from './expense-report';
import { ExpenseReportLineAttachment } from './expense-report-line-attachment';
import { ExpenseType } from './expense-type';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ExpenseReportLine extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  amount!: number;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  description?: string;
  expenseDate!: Date;
  expenseReportId!: number;
  expenseTypeId!: number;
  notes?: string;
  attachments!: ExpenseReportLineAttachment[];
  expenseReport!: ExpenseReport;
  expenseType!: ExpenseType;
}

